import { Badge } from "../ui/badge";
import { ArrowRight, Clock3 } from "lucide-react";
import type { RescueCase } from "@io-spoke/contracts/rescue";

function money(cents: number, currency: string) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(cents / 100);
}

function daysUntil(value: string) {
  return Math.max(0, Math.ceil((new Date(value).getTime() - Date.now()) / 86_400_000));
}

export function RescueRadarCard({ rescueCase, selected, onSelect }: {
  rescueCase: RescueCase;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <article className={`group border-b border-border bg-card transition-colors first:rounded-t-lg last:rounded-b-lg last:border-b-0 ${selected ? "relative bg-orange-50 before:absolute before:inset-y-0 before:left-0 before:w-0.5 before:bg-orange-500 dark:bg-orange-950/20" : "hover:bg-muted/45"}`}>
      <button type="button" onClick={onSelect} aria-label={`Open rescue case for ${rescueCase.customerName}`} className="w-full p-4 text-left outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="truncate text-sm font-semibold">{rescueCase.customerName}</h2>
          <p className="mt-1 line-clamp-1 text-xs text-muted-foreground">{rescueCase.promise}</p>
        </div>
        <div className="shrink-0 text-right">
          <div className="text-sm font-semibold tabular-nums">{money(rescueCase.annualValueCents, rescueCase.currency)}</div>
          <div className="text-[11px] text-muted-foreground">annual value</div>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between gap-2 text-xs">
        <div className="flex flex-wrap items-center gap-2">
          <Badge className="border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-300">Risk assessment {rescueCase.riskScore}/100</Badge>
          <span className="inline-flex items-center gap-1 text-muted-foreground"><Clock3 className="h-3.5 w-3.5" /> {daysUntil(rescueCase.renewalAt)} days</span>
          <span className="text-muted-foreground">{rescueCase.status === "active" ? "Active" : "Needs intervention"}</span>
        </div>
        <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </div>
      </button>
    </article>
  );
}
